<template>
  <router-view />
</template>

<script>
import { defineComponent } from 'vue'
import * as THREE from 'three'

export default defineComponent({
  setup() {
    console.log(THREE)
  },
})
</script>


<style>
@import url('https://fonts.googleapis.com/css2?family=M+PLUS+Rounded+1c&display=swap');

*
{
    margin: 0;
    padding: 0;
}

#app {
  font-family: 'M PLUS Rounded 1c', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* #app::-webkit-scrollbar {
  display: none;
}

#nav {
  position: absolute;
  padding: 30px;
} */

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

a:visited {
  color: #353e47;
}

a:hover{
  text-decoration: none;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
